import type { Params } from '@angular/router'

// The instance whose data panel is open, often a subprocess. Kept apart from the SDK's
// `processInstanceUuid`, which names the instance the renderer resumes on reload.
export const INSPECTED_PROCESS_UUID_PARAM = 'inspectedProcessUuid'

/** Until a subprocess is opened, the panel follows the instance the SDK resumes; `processUuid` is the old name. */
export const inspectedProcessUuid = (params: Params): string | undefined =>
  params[INSPECTED_PROCESS_UUID_PARAM] ?? params['processInstanceUuid'] ?? params['processUuid']
